import UpdateConfig from './UpdateConfig';

export default UpdateConfig;
